<template>
  <div class="bg-white rounded-md">
    <div>
      <div>
        <img
          class="w-full object-cover"
          src="https://homesby360.s3.amazonaws.com/bg2.jpg"
          alt="homesby360"
        />
      </div>
      <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5">
          <div class="flex">
            <img
              v-if="user.profile.image_url"
              class="h-24 w-24 rounded-full ring-4 ring-white sm:h-32 sm:w-32 object-cover"
              :src="user.profile.image_url"
              alt="RealtorImage"
            />
            <img
              v-else
              class="h-24 w-24 rounded-full ring-4 ring-white sm:h-32 sm:w-32 object-cover"
              :src="url + user.name + rest"
              alt="RealtorImage"
            />

            <div class="mt-12 sm:mt-16 ml-4">
              <h1 class="text-2xl font-bold text-gray-700 truncate">
                {{ user.name }}

                <div class="flex items-center">
                  <div class="group relative flex items-left">
                    <label
                      for="user_photo"
                      class="rounded-lg bg-green-600 shadow-sm px-2 cursor-pointer hover:bg-green-700 relative text-sm leading-4 text-white"
                    >
                      <span>
                        <i class="fas fa-camera-retro h-4 w-4"></i> Update
                        profile image</span
                      >
                    </label>
                    <input
                      accept="image/png, image/jpeg, image/jpg"
                      id="user_photo"
                      name="user_photo"
                      @change="uploadFile"
                      type="file"
                      class="absolute w-full h-full opacity-0 cursor-pointer"
                    />
                  </div>
                </div>
              </h1>
            </div>
          </div>

          <div class="sm:mb-6">
            <nav class="sm:space-x-4 space-y-2 p-2" aria-label="Tabs">
              <button
                @click="showDashboard"
                class="w-full sm:w-auto  bg-white rounded-full text-gray-700 shadow-md hover:text-gray-700 hover:shadow-lg py-2 px-2 font-light text-sm"
              >
                <span
                  ><i class="text-green-600  fas fa-home fa-home mr-1"></i>
                  Dashboard</span
                >
              </button>

              <button
                @click="displayListings"
                class="w-full sm:w-auto bg-white rounded-full text-gray-700 shadow-md hover:text-gray-700 py-2 hover:shadow-lg px-2 font-light text-sm"
              >
                <span
                  ><i class="text-blue-500 fas fa-search mr-1"></i>Search
                  Homes</span
                >
              </button>

              <button
                @click="showDocs"
                class="w-full sm:w-auto bg-white rounded-full text-gray-700 shadow-md hover:text-gray-700 hover:shadow-lg py-2 px-2 font-light text-sm"
              >
                <span
                  ><i class="text-red-500 far fa-file-pdf mr-1"></i> Paper
                  Work</span
                >
              </button>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <div class="max-w-7xl mx-auto">
      <div class="bg-gray-50 p-2">
        <v-btn
          @click="showDialog = true"
          class="float-right"
          x-small
          color="info"
          rounded
          dark
        >
          Update Password</v-btn
        >

        <form class="py-2 rounded-md space-y-8 divide-y divide-gray-200">
          <div class="px-2 space-y-8 divide-y divide-gray-200">
            <div
              class="py-2 mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
            >
              <div class="sm:col-span-2">
                <label
                  for="name"
                  class="block text-sm font-medium text-gray-700"
                >
                  <i class="fas fa-user"></i> Name
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="user.name"
                    class="p-1 border text-gray-400 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
              </div>

              <div class="sm:col-span-2">
                <label
                  for="email"
                  class="block text-sm font-medium text-gray-700"
                >
                  <i class="fas fa-envelope"></i> Email
                </label>
                <div class="mt-1">
                  <input
                    type="email"
                    v-model="user.email"
                    class="p-1 border text-gray-400 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
              </div>

              <div class="sm:col-span-2">
                <label
                  for="phone"
                  class="block text-sm font-medium text-gray-700"
                >
                  <i class="fas fa-phone-alt"></i> Phone
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="user.phone"
                    class="p-1 border shadow-sm text-gray-400 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
              </div>

              <div class="sm:col-span-6 relative sm:mt-4">
                <div
                  class="absolute inset-0 flex items-center"
                  aria-hidden="true"
                >
                  <div class="w-full border-t border-gray-300"></div>
                </div>
                <div class="relative flex justify-center">
                  <span class="font-bold px-2 bg-white text-sm text-gray-500">
                    Mailing Address
                  </span>
                </div>
              </div>

              <div class="sm:col-span-2">
                <label
                  for="street-address"
                  class="block text-sm font-medium text-gray-700"
                >
                  <i class="fas fa-address-book"></i> Street
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    autocomplete="street-address"
                    v-model="user.profile.address"
                    class="p-1 border shadow-sm text-gray-400 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
              </div>

              <div class="sm:col-span-2">
                <label
                  for="city"
                  class="block text-sm font-medium text-gray-700"
                >
                  <i class="far fa-building"></i> City
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="user.profile.city"
                    class="p-1 border shadow-sm text-gray-400 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
              </div>

              <div class="sm:col-span-2">
                <label
                  for="state"
                  class="block text-sm font-medium text-gray-700"
                >
                  <i class="fas fa-city"></i> State / Province
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="user.profile.state"
                    class="p-1 border shadow-sm text-gray-400 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
              </div>

              <div class="sm:col-span-2 sm:mt-8">
                <label
                  for="zip"
                  class="block text-sm font-medium text-gray-700"
                >
                  <i class="fas fa-user-md"></i> Occupation
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="user.profile.occupation"
                    class="p-1 border shadow-sm text-gray-400 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
              </div>

              <div class="sm:col-span-2 sm:mt-8">
                <label
                  for="zip"
                  class="block text-sm font-medium text-gray-700"
                >
                  <i class="far fa-money-bill-alt"></i> Final Purchase Price
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="user.profile.final_purchase_price"
                    class="p-1 border text-gray-400 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
              </div>

              <div class="sm:col-span-2 sm:mt-8">
                <label
                  for="zip"
                  class="block text-sm font-medium text-gray-700"
                >
                  <i class="far fa-calendar-alt"></i> Move in Date
                  <span class="text-xs text-blue-600"
                    >{{ formatDate(user.profile.close_by) }}
                  </span>
                </label>
                <div class="mt-1">
                  <input
                    type="date"
                    v-model="user.profile.close_by"
                    class="-mt-1 p-1 text-gray-400 border shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
              </div>

              <div class="sm:col-span-6 text-right">
                <button
                  @click.prevent="updateUser(user)"
                  class=" sm:-mt-8 py-1 px-3 border border-transparent shadow-sm text-sm font-medium rounded-lg text-white bg-green-600 hover:bg-green-700 focus:outline-none"
                >
                  Save
                </button>
              </div>
            </div>

            <div class="p-4 bg-gray-200">
              <div class="relative mb-4">
                <div
                  class="absolute inset-0 flex items-center"
                  aria-hidden="true"
                >
                  <div class="w-full border-t border-gray-300"></div>
                </div>
                <div class="relative flex justify-center">
                  <button
                    @click="addSpouse = !addSpouse"
                    type="button"
                    class="inline-flex items-center shadow-sm px-4 py-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    <!-- Heroicon name: solid/plus-sm -->
                    <svg
                      class="-ml-1.5 mr-1 h-5 w-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    <span>Spouse</span>
                  </button>
                </div>
              </div>

              <v-fade-transition v-if="addSpouse" mode="out-in">
                <spouse :user="user"></spouse>
              </v-fade-transition>
            </div>

            <div class="p-4 bg-gray-200">
              <div class="relative mb-4">
                <div
                  class="absolute inset-0 flex items-center"
                  aria-hidden="true"
                >
                  <div class="w-full border-t border-gray-300"></div>
                </div>
                <div class="relative flex justify-center">
                  <button
                    @click="addLender = !addLender"
                    type="button"
                    class="inline-flex items-center shadow-sm px-4 py-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    <!-- Heroicon name: solid/plus-sm -->
                    <svg
                      class="-ml-1.5 mr-1 h-5 w-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    <span>Lender</span>
                  </button>
                </div>
              </div>

              <v-fade-transition v-if="addLender" mode="out-in">
                <lender :user="user"></lender>
              </v-fade-transition>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- update password      -->
    <v-dialog v-model="showDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h6">New Password</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form v-model="valid">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    :counter="20"
                    v-model="form.password"
                    :rules="[v => !!v || 'password is required']"
                    type="password"
                    label="Password"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    type="password"
                    v-model="form.password_confirmation"
                    :rules="[
                      form.password === form.password_confirmation ||
                        'Password must match'
                    ]"
                    label="Password Confirmation"
                    required
                  ></v-text-field>
                </v-col>
                <span class="text-danger" v-if="errors.password">
                  {{ errors.password[0] }}
                </span>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="valid"
            color="blue darken-1"
            dark
            :disabled="!valid"
            @click="updatePass(user)"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import moment from "moment";
import Swal from "sweetalert2";
import Lender from "./Lender.vue";
import Spouse from "./Spouse.vue";
export default {
  name: "Buyer-Profile",
  props: ["user"],
  components: { Lender, Spouse },
  data() {
    return {
      url: "https://ui-avatars.com/api/?name=",
      rest: "&background=ccf3ff&color=0099cc",
      addLender: false,
      addSpouse: false,
      image: "",
      showDialog: false,
      valid: true,
      form: {
        password: "",
        password_confirmation: ""
      },
      errors: []
    };
  },

  methods: {
    formatDate(date) {
      return moment.utc(date).format("MMMM Do YYYY");
    },

    updateUser(user) {
      window.axios
        .post("/api/userUpdated/" + user.id, {
          name: user.name,
          email: user.email,
          phone: user.phone,
          address: user.profile.address,
          city: user.profile.city,
          state: user.profile.state,
          occupation: user.profile.occupation,
          moveDate: user.profile.close_by,
          finalPrice: user.profile.final_purchase_price
        })
        .then(() => {
          this.$store.dispatch("getUser");
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "User successfully updated",
            showConfirmButton: false,
            timer: 1500
          });
        });
    },

    updatePass(user) {
      window.axios
        .post("/api/updatePassword/" + user.id, {
          password: this.form.password
        })
        .then(() => {
          this.$store.dispatch("getUser");
          this.showDialog = false;
          this.errors = [];
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Password successfully updated",
            showConfirmButton: false,
            timer: 1500
          });
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
        });
    },

    displayListings() {
      this.$router.push({ name: "listings" });
    },

    showDocs() {
      this.$emit("showWelcome");
    },

    showDashboard() {
      this.$emit("showDashboard");
    },

    uploadFile(e) {
      this.image = e.target.files || e.dataTransfer.files;
      var config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };

      let formData = new FormData();

      $.each(this.image, function(key, image) {
        formData.append(`image[${key}]`, image);
      });

      formData.append("userId", this.user.id);

      window.axios.post("api/updateProfileImage", formData, config).then(
        () => this.$store.dispatch("getUser"),
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Image successfully updated",
          showConfirmButton: false,
          timer: 1500
        })
      );
    }
  }
};
</script>
